// Listing option lists shared by the wizard (ListPropertyNew), the edit form
// (EditProperty), the browse filters and the renter profile. Amenities come
// from the registry in src/lib/amenities.ts (keys, groups, facets, synonyms);
// this module keeps the historical names so its importers stay untouched.
export {
  AMENITY_OPTIONS,
  PET_OPTIONS,
  isPetOption,
  normalizeAmenities,
} from "@/lib/amenities";

// "Internet" is the owner's answer (internet_included, Oct 17, backlog
// ab1084a1), separate from whether the home has WiFi.
export const SERVICE_OPTIONS = [
  "Cleaning", "Electricity", "Gardener", "Internet", "Pool Manager", "Property Manager", "Water",
];
